(() => {
  const key = 'uykumo:scratch-shown';
  let shownThisPage = false;
  const seen = () => {
    if (shownThisPage) return true;
    try { if (localStorage.getItem(key) === '1' || localStorage.getItem('theme:popup-filled') === 'true') return true; } catch (_) {}
    try { if (sessionStorage.getItem(key) === '1') return true; } catch (_) {}
    return document.cookie.split(';').some(c => c.trim() === 'uykumo_scratch_seen=1');
  };
  const remember = () => {
    shownThisPage = true;
    try { localStorage.setItem(key, '1'); } catch (_) {}
    try { sessionStorage.setItem(key, '1'); } catch (_) {}
    document.cookie = 'uykumo_scratch_seen=1; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
  };
  function init() {
    document.querySelectorAll('[data-scratch-popup]').forEach(dialog => {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      const ticket = dialog.querySelector('[data-scratch-ticket]');
      const canvas = ticket.querySelector('canvas');
      const ctx = canvas.getContext('2d');
      const alternate = dialog.querySelector('[data-scratch-reveal]');
      let revealed = false, active = false, last = null, moves = 0;
      function reveal(focus = true) {
        if (revealed) return;
        revealed = true;
        ticket.dataset.started = 'true';
        ticket.dataset.revealed = 'true';
        ticket.querySelector('.us-prize').removeAttribute('aria-hidden');
        alternate.hidden = true;
        dialog.querySelector('[data-scratch-offer]').hidden = false;
        if (focus) dialog.querySelector('[data-scratch-focus]').focus({preventScroll:true});
      }
      if (ctx) {
        const gradient = ctx.createLinearGradient(0,0,600,260);
        gradient.addColorStop(0,'#bda778');gradient.addColorStop(.45,'#f0e4c7');gradient.addColorStop(1,'#c5af81');
        ctx.fillStyle=gradient;ctx.fillRect(0,0,600,260);
        ctx.strokeStyle='#fff4';ctx.lineWidth=1;
        for(let x=-260;x<600;x+=24){ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x+260,260);ctx.stroke();}
        ctx.globalCompositeOperation='destination-out';ctx.strokeStyle='#000';ctx.fillStyle='#000';ctx.lineWidth=60;ctx.lineCap='round';ctx.lineJoin='round';
        const point=e=>{const r=canvas.getBoundingClientRect();return {x:(e.clientX-r.left)*600/r.width,y:(e.clientY-r.top)*260/r.height};};
        const scratch=e=>{
          if(!active||revealed)return;
          const p=point(e);ticket.dataset.started='true';
          ctx.beginPath();ctx.moveTo(last?last.x:p.x,last?last.y:p.y);ctx.lineTo(p.x,p.y);ctx.stroke();
          ctx.beginPath();ctx.arc(p.x,p.y,24,0,Math.PI*2);ctx.fill();last=p;
          if(++moves%5===0){const data=ctx.getImageData(0,0,600,260).data;let cleared=0,total=0;for(let i=3;i<data.length;i+=64){total++;if(data[i]<128)cleared++;}if(cleared/total>.25)reveal();}
        };
        canvas.addEventListener('pointerdown',e=>{active=true;last=null;canvas.setPointerCapture(e.pointerId);scratch(e);});
        canvas.addEventListener('pointermove',scratch);
        for(const name of ['pointerup','pointercancel','lostpointercapture'])canvas.addEventListener(name,()=>{active=false;last=null;});
      }
      alternate.addEventListener('click',()=>reveal());
      dialog.querySelectorAll('[data-scratch-close]').forEach(b=>b.addEventListener('click',()=>dialog.close()));
      dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});
      const response=dialog.querySelector('[data-scratch-response]');
      let pendingResponse = false;
      try {
        pendingResponse = Boolean(response) && sessionStorage.getItem('uykumo:scratch-submitted') === '1';
        sessionStorage.removeItem('uykumo:scratch-submitted');
      } catch (_) {}
      dialog.querySelector('form').addEventListener('submit', () => {
        remember();
        try { sessionStorage.setItem('uykumo:scratch-submitted', '1'); } catch (_) {}
      });
      dialog.addEventListener('close', remember);
      dialog.addEventListener('cancel', remember);
      if (pendingResponse) reveal(false);
      if (pendingResponse || !seen()) {
        remember();
        dialog.showModal();
      }

    });
  }
  init();document.addEventListener('shopify:section:load',init);
})();
